import { FilterData, FilterOptionsMap } from './Filter.types';

export const hasAllDependencies = (stateKeys: string[], dependsOn?: string[]): boolean => {
  if (!dependsOn || dependsOn.length === 0) {
    return true;
  }
  return dependsOn.every((key) => stateKeys.includes(key));
};

export const getMissingDependencies = (stateKeys: string[], dependsOn?: string[]): string[] => {
  if (!dependsOn || dependsOn.length === 0) {
    return [];
  }
  return dependsOn.filter((category) => !stateKeys.includes(category));
};

export const getDependents = (data: FilterData, categoryKey: string, filtersDependOn?: string[]): string[] => {
  const dependents: string[] = [];
  if (filtersDependOn && filtersDependOn.includes(categoryKey)) {
    Object.keys(data).forEach((category) => {
      if (data[category].type !== 'select') {
        dependents.push(category);
      }
    });
  } else {
    Object.keys(data).forEach((category) => {
      if (Object.keys(data[category].dependsOn || {}).includes(categoryKey)) {
        dependents.push(category);
      }
    });
  }
  return dependents;
};

export const getOptionLabel = (option: string, optionsMap?: FilterOptionsMap) => {
  if (!optionsMap) {
    return option;
  }
  return optionsMap[option] || option;
};
